import { UrlKind, ValidatedUrlModule_create } from "../HttpV2.js";
import { printf, toText } from "../fable_modules/fable-library.3.7.20/String.js";
import { singleton } from "../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { FSharpResult$2 } from "../fable_modules/fable-library.3.7.20/Choice.js";
import { defaultArg } from "../fable_modules/fable-library.3.7.20/Option.js";
import { CaseStrategy } from "../fable_modules/Thoth.Json.10.2.0/Types.fs.js";
import { option_type, string_type, list_type, equals } from "../fable_modules/fable-library.3.7.20/Reflection.js";
import { TransferHistory$reflection, ContractTypePriceDTO$reflection, ContractType$reflection, Contract$reflection } from "../Containers/Invoicee/Common.js";
import { Auto_generateBoxedDecoder_79988AEF, fromString } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { compareArrays, equals as equals_1, uncurry } from "../fable_modules/fable-library.3.7.20/Util.js";
import { ValidatedUrlModule_value, addClientReference, Http_get_ExtraCoders } from "../HttpV2.js";
import { Http_request, Http_method, Http_withCredentials, Http_send } from "../fable_modules/Fable.SimpleHttp.3.0.0/Http.fs.js";
import { HttpMethod } from "../fable_modules/Fable.SimpleHttp.3.0.0/Types.fs.js";
import { createThunk } from "../Redux/Redux.js";
import { setTransferHistory, setContractTypes, setContracts } from "../Redux/Reducers/ContractReducer.js";
import { LoadState$2 } from "../Global.js";
import { startImmediate } from "../fable_modules/fable-library.3.7.20/Async.js";
import { fold, sortByDescending } from "../fable_modules/fable-library.3.7.20/List.js";
import { ContractCurrentState, ContractCurrentStateModule_fromString } from "../DomainTypes.js";
import { empty, add } from "../fable_modules/fable-library.3.7.20/Map.js";

export function loadContracts(clientNr, invoiceeNr) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(1, toText(printf("/invoicee/%i/%i/contracts"))(clientNr)(invoiceeNr)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg_2 = defaultArg(new CaseStrategy(2), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(list_type(Contract$reflection()), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(list_type(Contract$reflection()), arg_2, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(list_type(Contract$reflection()), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

export function loadContractsThunk(clientNr, invoiceeNr) {
    return createThunk((dispatch) => ((getState) => {
        if (getState().Contract.Contracts.tag === 1) {
        }
        else {
            const dispatchSetContractsAction = (arg) => {
                dispatch(setContracts(arg));
            };
            dispatchSetContractsAction(new LoadState$2(1));
            startImmediate(singleton.Delay(() => singleton.Bind(loadContracts(clientNr, invoiceeNr), (_arg) => {
                const result = _arg;
                dispatchSetContractsAction((result.tag === 1) ? (new LoadState$2(3, result.fields[0])) : (new LoadState$2(2, sortByDescending((c) => {
                    const state = ContractCurrentStateModule_fromString(c.CurrentState);
                    return [equals_1(state, new ContractCurrentState(0)), equals_1(state, new ContractCurrentState(1)), equals_1(state, new ContractCurrentState(2)), c.CancelledDate, c.ContractNumber];
                }, result.fields[0], {
                    Compare: compareArrays,
                }))));
                return singleton.Zero();
            })));
        }
    }));
}

export function loadContractTypes(clientNr) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/Data/ContractType/%i/"))(clientNr)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(list_type(ContractType$reflection()), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(list_type(ContractType$reflection()), arg_1, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(list_type(ContractType$reflection()), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

export function loadContractTypesThunk(clientNr, forceReload) {
    return createThunk((dispatch) => ((getState) => {
        const loadFn = () => {
            const dispatchSetContractTypesAction = (arg) => {
                dispatch(setContractTypes(arg));
            };
            dispatchSetContractTypesAction(new LoadState$2(1));
            startImmediate(singleton.Delay(() => singleton.Bind(loadContractTypes(clientNr), (_arg) => {
                const result = _arg;
                dispatchSetContractTypesAction((result.tag === 1) ? (new LoadState$2(3, result.fields[0])) : (new LoadState$2(2, fold((state, ct) => add(ct.ContractTypeCode, ct, state), empty(), result.fields[0]))));
                return singleton.Zero();
            })));
        };
        const matchValue = getState().Contract.ContractTypes;
        switch (matchValue.tag) {
            case 1: {
                break;
            }
            case 2: {
                if (forceReload) {
                    loadFn();
                }
                break;
            }
            default: {
                loadFn();
            }
        }
    }));
}

export function loadContractTypePriceIds(clientNr) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/Data/ContractTypePrice/%i/"))(clientNr)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(list_type(ContractTypePriceDTO$reflection()), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(list_type(ContractTypePriceDTO$reflection()), arg_1, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(list_type(ContractTypePriceDTO$reflection()), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

export function loadContractTransfers(clientNr, contractNr) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/History/NumberChange/%i/%i/TransferredToFrom"))(clientNr)(contractNr)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg_2 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(option_type(TransferHistory$reflection()), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(option_type(TransferHistory$reflection()), arg_2, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(option_type(TransferHistory$reflection()), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

export function loadContractTransfersThunk(clientNr, contractNr) {
    return createThunk((dispatch) => ((getState) => {
        if (getState().Contract.TransferHistory.tag === 1) {
        }
        else {
            const dispatchSetTransferHistoryAction = (arg) => {
                dispatch(setTransferHistory(arg));
            };
            if (getState().Contract.TransferHistory.tag === 2) {
            }
            else {
                dispatchSetTransferHistoryAction(new LoadState$2(1));
            }
            startImmediate(singleton.Delay(() => singleton.Bind(loadContractTransfers(clientNr, contractNr), (_arg) => {
                const result = _arg;
                dispatchSetTransferHistoryAction((result.tag === 1) ? (new LoadState$2(3, result.fields[0])) : (new LoadState$2(2, result.fields[0])));
                return singleton.Zero();
            })));
        }
    }));
}

